import { DirectiveOptions } from 'vue';
import { isInParent } from '@/shared/filters/utils-filter';

const directive: DirectiveOptions = {
    bind(el, binding, node) {
        let scrollEvent = () => {
            let child = el.children[el.children.length - 1]
            if (isInParent(child)) {
                el.classList.add(binding.value);
            } else {
                el.classList.remove(binding.value);
            }
        }
        el.addEventListener('scroll', scrollEvent);
    }
};

export default directive;